<template>
  <div class="RouteOrderEdit">
    <fy-form
      :model="name_info"
      :rules="rules"
      class="fy-form-travel_person_update"
      ref="form"
      v-if="!isInit"
    >
      <div class="RouteOrderNameList">
        <div class="travel_person_update">
          <div v-for="(column, index) in columns">
            <div class="travel_person_update_line" v-if="column.column_enname == 'name' ">
              <div class="travel_person_left">
                <em>*</em>
                <i>姓名</i>
              </div>
              <input
                @click="getNameKey(index)"
                id="name"
                placeholder="必填"
                style="width: 35%;"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="column.column_enname == 'sex' ">
              <div class="travel_person_left">
                <em>*</em>
                <i>性别</i>
              </div>
              <div class="travel_person_right travel_person_gender">
                <span>
                  <div @click="name_info['field' + index]='男'">
                    <i v-bind:class="{sex_cls: name_info['field' + index]=='男'}"></i>
                  </div>
                  <em>男</em>
                </span>
                <span>
                  <div @click="name_info['field' + index]='女'">
                    <i v-bind:class="{sex_cls: name_info['field' + index]=='女'}"></i>
                  </div>
                  <em>女</em>
                </span>
              </div>
            </div>
            <div v-else-if="column.column_enname == 'nationality'">
              <div class="travel_person_update_line travel_person_nationality">
                <div class="travel_person_left">
                  <em>*</em>
                  <i>国籍</i>
                </div>
                <select
                  id="nationality"
                  name="nationality"
                  style=" margin-top: 0;"
                  v-model.trim="name_info['field' + index]"
                >
                  <option value="中国大陆">中国大陆</option>
                  <option value="中国香港">中国香港</option>
                  <option value="中国澳门">中国澳门</option>
                  <option value="中国台湾">中国台湾</option>
                  <option value>其他</option>
                </select>
                <div class="travel_person_update_lineimg">
                  <img alt src="@/assets/images/customer/bottomarrow3_03.png">
                </div>
              </div>
              <fy-form-item
                :label="fields.nationality2.field_name"
                :prop="fields.nationality2.field_enname"
                v-if="!name_info['field' + index]"
              >
                <fy-input
                  :placeholder="fields.nationality2.field_placeholder"
                  type="text"
                  v-model="name_info['field' + index]"
                ></fy-input>
              </fy-form-item>
            </div>
            <div v-else-if="column.column_enname == 'person_type'">
              <fy-form-item
                :label="fields.person_type.field_name"
                :prop="fields.person_type.field_enname"
              >
                <fy-select
                  :options="person_type_list"
                  labelKey="category"
                  v-model="name_info['field' + index]"
                  valueKey="category_code"
                ></fy-select>
                <div class="travel_person_update_lineimg arrow">
                  <img alt src="@/assets/images/customer/bottomarrow3_03.png">
                </div>
              </fy-form-item>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="column.column_enname == 'credentials_type' "
            >
              <!-- 国内证件 -->
              <div class="travel_person_left">
                <i>证件类型</i>
              </div>
              <select style=" margin-top: 0;" v-model.trim="name_info['field' + index]">
                <option value>请选择</option>
                <option
                  :value="option.category_code"
                  v-for="option in credentials_type_list"
                >{{option.category}}</option>
              </select>
              <div class="travel_person_update_lineimg">
                <img alt src="@/assets/images/customer/bottomarrow3_03.png">
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="column.column_enname == 'id_card_no' "
            >
              <div class="travel_person_left">
                <i>证件号</i>
              </div>
              <input placeholder="请输入正确的证件号码" type="text" v-model.trim="name_info['field' + index]">
            </div>
            <div v-else-if="column.column_enname=='visa_type'">
              <div class="travel_person_update_line">
                <!-- 是否已有签证 -->
                <div class="travel_person_left">
                  <i>是否已有签证</i>
                </div>
                <div class="travel_person_right travel_person_visa">
                  <span>
                    <div @click="excess_info.is_have_visa='有'">
                      <i v-bind:class="{is_have_visa_cls: excess_info.is_have_visa=='有'}"></i>
                    </div>
                    <em>有</em>
                  </span>
                  <span>
                    <div @click="excess_info.is_have_visa='无'">
                      <i v-bind:class="{is_have_visa_cls: excess_info.is_have_visa=='无'}"></i>
                    </div>
                    <em>无</em>
                  </span>
                </div>
              </div>
              <div
                class="travel_person_update_line travel_person_update_visa"
                v-show="excess_info.is_have_visa=='有'"
              >
                <div class="travel_person_left">&nbsp;</div>
                <input
                  id="visa"
                  placeholder="护照有效期须6个月以上"
                  type="text"
                  v-model.trim="name_info['field' + index]"
                >
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="column.column_enname == 'visa_date_of_expiry'"
            >
              <!-- 签证有效期 -->
              <div class="travel_person_left">
                <i>签证有效期</i>
              </div>
              <input
                id="id_depart_time5"
                name="visa_date_of_expiry"
                placeholder="请选择"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time5-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div class="travel_person_update_line" v-else-if="column.column_enname == 'where_visa'">
              <!-- 签证签发地 -->
              <div class="travel_person_left">
                <i>签证签发地</i>
              </div>
              <input placeholder="请输入" type="text" v-model.trim="name_info['field' + index]">
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'visa_date_of_issue'==column.column_enname"
            >
              <!-- 签证签发日期 -->
              <div class="travel_person_left">
                <i>签证签发日期</i>
              </div>
              <input
                name="visa_date_of_issue"
                placeholder="请选择"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time4-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'type_of_endorsement'==column.column_enname"
            >
              <!-- 签注类型 -->
              <div class="travel_person_left">
                <i>签注类型</i>
              </div>
              <select
                name="type_of_endorsement"
                style=" margin-top: 0;"
                v-model.trim="name_info['field' + index]"
              >
                <option value>请选择</option>
                <option
                  :value="option.category_code"
                  v-for="option in credentials_type_list"
                >{{option.category}}</option>
              </select>
              <div class="travel_person_update_lineimg">
                <img alt src="@/assets/images/customer/bottomarrow3_03.png">
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'credentials_date_of_expiry'==column.column_enname"
            >
              <!-- 证件有效期-->
              <div class="travel_person_left">
                <i>证件有效期</i>
              </div>
              <input
                id="id_depart_time3"
                name="credentials_date_of_expiry"
                placeholder="请选择"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time3-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'credentials_date_of_issue'==column.column_enname"
            >
              <!-- 证件签发日期-->
              <div class="travel_person_left">
                <i>证件签发日期</i>
              </div>
              <input
                id="id_depart_time2"
                name="credentials_date_of_issue"
                placeholder="请选择"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time2-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'where_credentials'==column.column_enname"
            >
              <!-- 证件签发地-->
              <div class="travel_person_left">
                <i>证件签发地</i>
              </div>
              <input
                name="where_credentials"
                placeholder="请输入"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
            </div>

            <div class="travel_person_update_line" v-else-if="'mobile_phone'==column.column_enname">
              <!-- 手机号码-->
              <div class="travel_person_left">
                <i>手机号码</i>
              </div>
              <input
                id="tel"
                name="mobile_phone"
                placeholder="请输入"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="column.column_enname=='en_name'">
              <!-- 拼音姓-->
              <div class="travel_person_left">
                <em></em>
                <i>拼音姓名</i>
              </div>
              <input
                placeholder="例：李明，填LI MING"
                type="text"
                v-model.trim="name_info['field' + index]"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'birthday'==column.column_enname">
              <!-- 出生年月日-->
              <div class="travel_person_left">
                <i>出生年月日</i>
              </div>
              <!-- <input type="text" name="birthday" placeholder="请选择" v-model.trim="name_info['field' + index]" id="id_depart_time1"> -->
              <div class="travel_person_date">
                <!-- <fy-mobile-date :start_date="$dateUtil.getNowDateAfterOrBeforeYear(-100)"
                                :end_date="new Date()"
                                v-model="name_info['field' + index]"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="new Date().getTime()"
                  :start_date="$dateUtil.getNowDateAfterOrBeforeYearTimestamp(-100)"
                  v-model="name_info['field' + index]"
                ></fy-el-date>
              </div>

              <!-- <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img src="@/assets/images/html/date_point_03.png" alt="" id="id_depart_time1-img">
              </div>-->
            </div>
            <div class="travel_person_update_line" v-else-if="column.column_enname == 'remark'">
              <!-- 备注-->
              <div class="travel_person_left">
                <i>备注</i>
              </div>
              <input type="text" v-model.trim="name_info['field' + index]">
            </div>
          </div>
          <div class="teavel_person_submit teavel_person_update">
            <input @click="save" type="button" value="保存">
          </div>
        </div>
      </div>
    </fy-form>
  </div>
</template>

<script>
export default {
  name: 'RouteOrderNameList',
  data () {
    return {
      isInit: true,
      name_list_id: 0,
      plan_id: 0,
      source: '',
      fields: {},
      rules: {},
      name_info: {},
      excess_info: {},
      columns: [],
      nationality2: '',
      name_key: '',

      /** 下拉选项 */
      person_type_list: [],
      credentials_type_list: [],
    }
  },
  watch: {
    name_info: {
      handler () {
        if (this.name_key) {
          this.name_info['name'] = this.name_info['field' + this.name_key]
        }
      },
      deep: true // 深度监控
    }
  },
  created () {
    this.name_list_id = this.$route.query.name_list_id
    this.plan_id = this.$route.query.plan_id
    this.source = this.$route.query.source
    this.getInfo()
    this.$pageField.init(this, 'fields', 'travelPersonUpdate').then(res => {
      this.isInit = false
    })
  },
  methods: {
    getNameKey (index) {
      this.name_key = index
    },
    getInfo () {
      var url = "name_list_info/info/" + this.name_list_id + "/" + this.plan_id + "/" + this.source
      this.$myGet(url, {})
        .then(res => {
          //this.name_info = res.response.data.name_list_info
          this.columns = res.response.data.columns
          var name_lists = this.$sessionStorageUtil.get('name_lists')
          for (var index in name_lists) {
            if (this.name_list_id == name_lists[index].name_list_info_id) {
              this.name_info = name_lists[index]
            }
          }
          console.log('res' + res)
          //this.$msg('获取名单信息成功','info',3000)
        })
        .catch(err => {
          console.log('err' + err)
          //this.$msg('获取名单信息失败','err',3000)
        })
    },
    save () {
      var name_lists = this.$sessionStorageUtil.get('name_lists')
      for (var index in name_lists) {
        if (this.name_list_id == name_lists[index].name_list_info_id) {
          name_lists[index] = this.name_info
        }
      }
      this.$sessionStorageUtil.set('name_lists', name_lists)
      this.$msg('保存名单信息成功', 'info', 3000)
      this.$pushByName('routeOrderEdit', { order_id: this.name_info.order_info_id })
    }
  },
}
</script>

<style lang="" scoped>
@import '../../../assets/css/pages/agent/second_phase.css';
.RouteOrderEdit {
  width: 500px;
  margin: 0 auto;
}
.travel_person_gender span div i.sex_cls {
  display: block;
}
.travel_person_visa span div i.is_have_visa_cls {
  display: block;
}
.travel_person_date {
  width: 60%;
  display: inherit;
  padding-top: -19px;
  margin-top: -10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/agent/route/routeOrderNameList.vue